import Vue from "vue";
import Router from "vue-router";

import {checkIsLogin} from "./utils/routerHandler";
import store from "./store";

Vue.use(Router);

const router = new Router({
    scrollBehavior() {
        return {x: 0, y: 0};
    },
    routes: [
        {
            path: "/",
            name: "index",
            component: () => import("./views/index/index.vue")
        },
        // {
        //   path: "/menu",
        //   name: "oldhome",
        //   component: () => import("./views/home/home.vue")
        // },
        {
            path: "/delivery",
            component: () => import("./components/layout/basic-layout.vue"),
            children: [
                {
                    path: "list",
                    name: "home",
                    component: () => import("./views/delivery/delivery-list.vue"),
                    props: {showStoreInfoFooter: true}
                },
                {
                    path: ":id",
                    name: "delivery/detail",
                    component: () => import("./views/delivery/delivery-detail.vue")
                }
            ]
        },
        {
            path: "/account",
            component: () => import("./components/layout/basic-layout.vue"),
            redirect: {name: "account/info"},
            beforeEnter: checkIsLogin,
            children: [
                {
                    path: "info",
                    name: "account/info",
                    component: () => import("./views/account/account.vue")
                },
                {
                    path: "edit",
                    name: "account/edit",
                    component: () => import("./views/account/account-edit.vue")
                }
            ]
        },
        {
            path: "/order",
            component: () => import("./components/layout/basic-layout.vue"),
            redirect: {name: "order/list"},
            beforeEnter: checkIsLogin,
            children: [
                {
                    path: "list",
                    name: "order/list",
                    component: () => import("./views/order/order-list.vue")
                },
                {
                    path: "appointment",
                    name: "order/appointment",
                    component: () => import("./views/order/appointment.vue")
                },
                {
                    path: "appointment/:guid",
                    name: "order/appointment/detail",
                    component: () => import("./views/order/appointmentDetail.vue")
                },
                {
                    path: ":guid",
                    name: "order/detail",
                    component: () => import("./views/order/order-detail.vue")
                }
            ]
        },
        {
            path: "/",
            component: () => import("./components/layout/basic-layout.vue"),
            children: [
                {
                    path: "login",
                    name: "login",
                    component: () => import("./views/login/login.vue"),
                    props: {showStoreInfoFooter: true}
                },
                {
                    path: "reset-newpassword",
                    name: "reset-newpassword",
                    component: () =>
                        import("./views/reset-password/reset-newpassword.vue")
                },
                {
                    path: "reset-password",
                    name: "reset-password",
                    component: () => import("./views/reset-password/reset-password.vue")
                },
                {
                    path: "forget-password",
                    name: "forget-password",
                    component: () => import("./views/reset-password/forget-password.vue")
                },
                {
                    path: "register",
                    name: "register",
                    component: () => import("./views/register/register.vue")
                },
                {
                    path: "checkout",
                    name: "checkout",
                    component: () => import("./views/checkout/checkout.vue"),
                    beforeEnter: checkIsLogin
                },
                {
                    path: "address",
                    name: "address",
                    component: () => import("./views/address/list.vue"),
                    beforeEnter: checkIsLogin
                },
                {
                    path: "address-edit/:guid",
                    name: "address/edit",
                    component: () => import("./views/address/edit.vue"),
                    beforeEnter: checkIsLogin
                },
                {
                    path: "address-create",
                    name: "address/create",
                    component: () => import("./views/address/create.vue"),
                    beforeEnter: checkIsLogin
                },
                {
                    path: "about",
                    name: "about",
                    component: () => import("./views/about-us/about-us.vue"),
                    props: {showStoreInfoFooter: true}
                },
                {
                    path: "reservar",
                    name: "reservar",
                    component: () => import("./views/reservar/reservar.vue"),
                    props: {showStoreInfoFooter: true}
                }
            ]
        }
    ]
});

router.beforeEach((to, from, next) => {
    console.log("进入路由跳转", to, from, next);
    if (to.name == "index") {
        next();
    } else {
        if (to.query.storeId && to.query.zipCode) {
            store.commit("setStoreId", to.query.storeId);
            store.commit("setZipCode", to.query.zipCode);
            next();
        } else if (store.state.storeId && store.state.zipCode) {
            next();
        } else {
            if (to.name == "home") {
                next();
            } else {
                next();
                // next({name: "index"});
            }
        }
    }
});

export default router;
